import {
  ApolloClient,
  ApolloLink,
  ApolloProvider,
  HttpLink,
  InMemoryCache,
  concat,
  from,
} from "@apollo/client";
import { RetryLink } from "@apollo/client/link/retry";
import { apolloConfig } from "config";
import React from "react";

import { removeTypenameFromVariables } from "@apollo/client/link/remove-typename";

import { getLocalToken, saveParseJson } from "data/functions";
// import { useAuth } from "react-oidc-context";

function ApolloContext({ children }) {
  const removeTypenameLink = removeTypenameFromVariables();
  // const auth = useAuth();
  const httpLink = new HttpLink({
    uri: apolloConfig.uri,
  });

  // const retryLink = new RetryLink({
  //   attempts: {
  //     max: 2,
  //     retryIf: (error) => !!error,
  //   },
  //   delay: {
  //     initial: 1000,
  //     jitter: true,
  //   },
  // });
  const authLink = new ApolloLink((operation, forward) => {
    // let data = operation.getContext();
    let token = getLocalToken();
    if (!token && !operation?.variables?.adminToken) return forward(operation);
    if (operation?.variables?.adminToken) {
      operation.setContext({
        headers: {
          authorization: `Bearer ${operation?.variables?.adminToken}`,
        },
      });
    } else
      operation.setContext(({ headers = {} }) => {
        return {
          headers: {
            ...headers,
            authorization: `Bearer ${token ? token : ""}`,
          },
        };
      });
    return forward(operation);
  });

  const link = from([
    removeTypenameLink,
    // retryLink,
    concat(authLink, httpLink),
  ]);

  const apolloClient = new ApolloClient({
    cache: new InMemoryCache({
      addTypename: false,
    }),
    link: link,
    name: "web",
    version: "1.0",
  });

  return (
    <ApolloProvider client={apolloClient} value={apolloClient}>
      {children}
    </ApolloProvider>
  );
}

export { ApolloContext };
